import { useEffect, useState } from 'react';
import './YabarbequedPage.css';

type Heart = {
  id: number;
  left: number;
  duration: number;
  delay: number;
  size: number;
};

function YabarbequedPage() {
  const [hearts, setHearts] = useState<Heart[]>([]);

  // Trigger a one-time "explosion" of hearts when the page first loads
  useEffect(() => {
    const HEART_COUNT = 40;
    const createdHearts: Heart[] = Array.from({ length: HEART_COUNT }).map((_, index) => ({
      id: index,
      left: Math.random() * 100,
      duration: 2 + Math.random() * 1.8,
      delay: Math.random() * 0.4,
      size: 18 + Math.random() * 26,
    }));

    setHearts(createdHearts);

    const timeout = window.setTimeout(() => {
      // Let the hearts finish animating, then clear them
      setHearts([]);
    }, 4500);

    return () => {
      window.clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="valentine-page">
      <div className="valentine-background">
        {hearts.map((heart) => (
          <span
            key={heart.id}
            className="heart-burst"
            style={{
              left: `${heart.left}%`,
              animationDuration: `${heart.duration}s`,
              animationDelay: `${heart.delay}s`,
              fontSize: `${heart.size}px`,
            }}
          >
            ❤️
          </span>
        ))}
      </div>

      <div className="valentine-card">
        <p className="valentine-slug">/yabarbequed</p>
        <h1 className="valentine-title">Be my valentine?</h1>

        <div className="valentine-options">
          <label className="valentine-pill">
            <input type="radio" name="valentine" value="yes" />
            <span>Yes</span>
          </label>
          <label className="valentine-pill">
            <input type="radio" name="valentine" value="ya-barbequed" />
            <span>Ya barbequed</span>
          </label>
        </div>

        <div className="valentine-section">
          <h2 className="valentine-question">Are you free 2/14/2026?</h2>
          <div className="valentine-options">
            <label className="valentine-pill">
              <input type="radio" name="availability" value="yes" />
              <span>Yes</span>
            </label>
            <label className="valentine-pill">
              <input type="radio" name="availability" value="maybe" />
              <span>Maybe</span>
            </label>
            <label className="valentine-pill">
              <input type="radio" name="availability" value="tentative" />
              <span>Tentative</span>
            </label>
          </div>
        </div>

        <div className="valentine-section">
          <h2 className="valentine-question">
            Food options with links, please select option on forms
          </h2>
          <ul className="valentine-food-list">
            <li>
              <a
                href="https://salypimientakitchentx.com/"
                target="_blank"
                rel="noreferrer"
              >
                Sal y Pimienta (Argentinean)
              </a>
            </li>
            <li>
              <a
                href="https://www.bistro-le-cep.com/"
                target="_blank"
                rel="noreferrer"
              >
                Bistro Le Cep (French)
              </a>
            </li>
            <li>
              <a
                href="https://www.hugosrestaurant.net/"
                target="_blank"
                rel="noreferrer"
              >
                Hugo&apos;s (Mexican upscale)
              </a>
            </li>
            <li>
              <a
                href="https://www.makiinthai.com/"
                target="_blank"
                rel="noreferrer"
              >
                MaKin (Thai upscale)
              </a>
            </li>
            <li>
              <a
                href="https://www.nirvanahouston.com/"
                target="_blank"
                rel="noreferrer"
              >
                Nirvana (Indian)
              </a>
            </li>
            <li>
              <a
                href="https://www.therouxpour.com/"
                target="_blank"
                rel="noreferrer"
              >
                The Rouxpour (Seafood)
              </a>
            </li>
            <li>
              <a
                href="https://www.ichijikuhouston.com/"
                target="_blank"
                rel="noreferrer"
              >
                Ichijiku Sushi (Omakase, apparently they have AYCE policy)
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/authenticmexicantacoplace/"
                target="_blank"
                rel="noreferrer"
              >
                Highway 6 Tacos
              </a>
            </li>
          </ul>
        </div>

        <div className="valentine-section">
          <h2 className="valentine-question">Google Form:</h2>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSftnO5JJqYs0MGSy0g7hnnlvyU13LQDfhYMwJeWXhA08e1i0w/viewform?usp=dialog"
            target="_blank"
            rel="noreferrer"
            className="valentine-form-link"
          >
            Valentine&apos;s Day 2026 Form
          </a>
        </div>
      </div>
    </div>
  );
}

export default YabarbequedPage;


